import Robot from './robotbase'


class Robotiq3F extends Robot {
	constructor() {
		super('Robotiq3F', 'robotiq_3f_gripper_visualization', 'cfg/robotiq-3f-gripper_articulated.xacro');

		this.robotRoot = 'palm';
		this.handRoot = 'palm';
		this.modelScale = 10;

		this.tcp.parent = 'tool0';
		this.tcp.position = [0, 0, 0];
	}
}

module.exports = new Robotiq3F();